import {
  HELP_LOCATION_MAC,
  HELP_LOCATION_LINUX,
  HELP_LOCATION_WINDOWS,
  HELP_LOCATION_DEFAULT,
} from 'utils/constants/externalLink'

export const isJSON = (str: string) => {
  if (typeof str === 'boolean') {
    return false
  }

  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const getOS = () => {
  const os = ['Windows', 'Linux', 'Mac'] as const
  return os.find((v) => navigator.appVersion.indexOf(v) >= 0)
}

export const getHelpLocationLink = () => {
  switch (getOS()) {
    case 'Mac':
      return HELP_LOCATION_MAC
    case 'Linux':
      return HELP_LOCATION_LINUX
    case 'Windows':
      return HELP_LOCATION_WINDOWS
    default:
      return HELP_LOCATION_DEFAULT
  }
}

export function removeLeadingZero(str: string) {
  if (str.charAt(0) === '0') {
    return str.substring(1)
  }
  return str
}
